












































































































































import AdUnit from "@/models/adUnit";
import { LineItem } from "@/models/campaign";
import {
  CampaignReportData,
  CampaignReportItem,
} from "@/models/CampaignReport";
import { DefinitionBatch, DefinitionList } from "@/models/definition";
import Site from "@/models/site";
import { get } from "lodash";
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AdUnitsSelector from "@/components/AdUnitsSelector.vue";
import { exportCSVFile } from "@/helpers/general";
import TableHeaderFilter from "@/components/TableHeaderFilter.vue";
import DefinitionValue from "@/models/definitionValue";
import { TableHeaderFilterGrouped, TableHeaderFilters } from "@/models/general";

@Component({ components: { AdUnitsSelector, TableHeaderFilter } })
export default class CampaignReportDailyDetail extends Vue {
  @Prop() loading!: boolean;
  @Prop() data!: CampaignReportData;
  @Prop() definitions!: DefinitionList[];
  @Prop() sites!: Site[];
  @Prop() adUnits!: AdUnit[];
  @Prop() lineItems!: LineItem[];

  selectedAdUnits: string[] = [];
  headers = [
    {
      text: this.$t("campaigns.model.site"),
      sortable: false,
      value: "siteId",
    },
    {
      text: this.$t("campaigns.line_items.date"),
      sortable: true,
      value: "date",
    },
    {
      text: this.$t("campaigns.model.ad_unit"),
      sortable: false,
      value: "adUnitId",
    },
    {
      text: this.$t("campaigns.model.definitions"),
      sortable: false,
      value: "definitionValueIds",
    },
    {
      text: this.$t("reports.campaign.clicks"),
      sortable: false,
      value: "clicks",
    },
    {
      text: this.$t("reports.campaign.prints"),
      sortable: false,
      value: "prints",
    },
  ];

  headersFilter: {
    sites: string[];
    adUnits: string[];
    definitions: string[];
  } = {
    sites: [],
    adUnits: [],
    definitions: [],
  };

  get dailyData(): CampaignReportItem[] {
    let data: CampaignReportItem[] = this.data.dailyData;

    if (this.headersFilter.adUnits.length > 0) {
      data = data.filter((d) => {
        return this.headersFilter.adUnits.indexOf(
          this.getLineItem(d.lineItemId).adUnitId
        ) !== -1
          ? true
          : false;
      });
    }

    if (this.headersFilter.sites.length > 0) {
      data = data.filter((d) => {
        return this.headersFilter.sites.indexOf(
          this.getLineItem(d.lineItemId).siteId
        ) !== -1
          ? true
          : false;
      });
    }
    console.log(this.data.dailyData.length);
    // FIX
    // Aproximación: Re agrupar definiciones en pares y validar que la tupla (1 o 2) de definiciones esten dentro de cada entry
    if (this.headersFilter.definitions.length > 0) {
      let defData = data;
      this.headersFilter.definitions.forEach((def) => {
        defData = data.filter((d) => {
          return this.getLineItem(d.lineItemId).definitionValueIds.indexOf(
            def
          ) !== -1
            ? true
            : false;
        });
      });
    }

    return data;
  }

  get getTotals(): { clicks: number; prints: number } {
    let clicks = 0;
    let prints = 0;
    this.dailyData.forEach((item) => {
      clicks += item.clicks;
      prints += item.prints;
    });

    return { clicks: clicks, prints: prints };
  }

  get adUnitHeadersFilter(): TableHeaderFilters[] {
    const filter: TableHeaderFilters[] = [];
    this.lineItems.forEach((l) => {
      const adUnit = this.adUnits.find((a) => l.adUnitId === a.id);
      const item: TableHeaderFilters = {
        id: adUnit?.id as string,
        value: adUnit?.name as string,
      };
      filter.find((f) => f.id === item.id) === undefined
        ? filter.push(item)
        : null;
    });

    return filter.sort((a, b) => {
      return a.value.localeCompare(b.value, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
  }

  get siteHeadersFilter(): TableHeaderFilters[] {
    const filter: TableHeaderFilters[] = [];

    this.lineItems.forEach((l) => {
      const site = this.sites.find((s) => l.siteId === s.id);
      const item: TableHeaderFilters = {
        id: site?.id as string,
        value: site?.name as string,
      };

      filter.find((f) => f.id === item.id) === undefined
        ? filter.push(item)
        : null;
    });
    return filter;
  }

  get definitionsHeadersFilter(): TableHeaderFilterGrouped[] {
    const filter: TableHeaderFilterGrouped[] = [
      {
        label: this.$t("definitions.labels.environment").toString(),
        filter: [],
      },
      {
        label: this.$t("definitions.labels.country").toString(),
        filter: [],
      },
    ];

    this.definitions.forEach((definition) => {
      definition.values.forEach((def) => {
        this.lineItems.forEach((l) => {
          const item = l.definitionValueIds.includes(def.id as string)
            ? def
            : null;

          if (item) {
            const f: TableHeaderFilters = {
              id: item.id as string,
              value: item.name,
            };
            if (definition.value === "environment") {
              filter[0].filter.find((i) => i.id === f.id) === undefined
                ? filter[0].filter.push(f)
                : null;
            } else {
              filter[1].filter.find((i) => i.id === f.id) === undefined
                ? filter[1].filter.push(f)
                : null;
            }
          }
        });
      });
    });

    return filter;
  }

  getLineItem(id: string): LineItem {
    const l = this.lineItems.find((i) => i.id === id);
    return l ? l : new LineItem();
  }

  getSite(id: string): string {
    const site = this.sites.find((e) => e.id === id);
    return site ? site.name : "";
  }

  getAdUnit(id: string): string {
    const adUnit = this.adUnits.find((e) => e.id === id);
    return adUnit ? adUnit?.name : "";
  }

  getDefinition(id: string): string {
    let definition;
    this.definitions.forEach((e) => {
      const value = e.values.find((d) => get(d, "id") === id);
      value ? (definition = value) : null;
    });
    return definition ? get(definition, "name") : "";
  }

  formatDate(date: string): string {
    return moment.utc(date).format("DD-MM-YYYY");
  }

  onSelect(id: string): void {
    // const lineItem = this.lineItems.find((l) => l.id === id);
    // lineItem ? (this.lineItem = lineItem) : null;
  }

  availableAdUnits(): AdUnit[] {
    const items: AdUnit[] = [];

    this.lineItems.forEach((l) => {
      if (items.find((i) => i.id === l.adUnitId) === undefined) {
        items.push(this.adUnits.find((a) => a.id === l.adUnitId) as AdUnit);
      }
    });

    return items.sort((a, b) => a.name.localeCompare(b.name));
  }

  filterByAdUnit(filter: string[]): void {
    this.headersFilter.adUnits = filter;
  }

  filterBySite(filter: string[]): void {
    this.headersFilter.sites = filter;
  }

  filterByDefinitions(filter: string[]): void {
    this.headersFilter.definitions = filter;
  }

  exportCsv(): void {
    const headers: string[] = [];

    headers.push(this.$t("campaigns.model.site") as string);
    headers.push(this.$t("campaigns.line_items.date") as string);
    headers.push(this.$t("campaigns.model.ad_unit") as string);
    headers.push(this.$t("definitions.labels.country") as string);
    headers.push(this.$t("definitions.labels.environment") as string);
    headers.push(this.$t("reports.campaign.clicks") as string);
    headers.push(this.$t("reports.campaign.prints") as string);

    const items: any = [];
    this.dailyData.forEach((d) => {
      const lineItem = this.getLineItem(d.lineItemId);
      const item = [
        this.getSite(lineItem.siteId),
        this.formatDate(d.date ? d.date.toString() : ""),
        this.getAdUnit(lineItem.adUnitId),
        this.getDefinition(lineItem.definitionValueIds[0]),
        this.getDefinition(lineItem.definitionValueIds[1]),
        d.clicks,
        d.prints,
      ];
      items.push(item);
    });

    exportCSVFile(
      headers,
      items,
      `daily_details_${moment().format("YYYY_MM_DD")}`
    );
  }
}
